// extracted by mini-css-extract-plugin
export var footer = "_p1-0";
export var inherit = "_p1-1";
export var input = "_p1-2";
export var modalContent = "_p1-3";
export var quillEditor = "_p1-4";
export var subtitle = "_p1-5";